export default __webpack_public_path__ + "static/media/signUpLeftImg.cdf91dc5.svg";